import { DeviceType } from '@/__generated__/graphql';

export const getIsGate = (deviceType: DeviceType) => {
  return deviceType === DeviceType.Cfc;
};
